import React, { Component } from 'react';
import { YMaps, Map } from 'react-yandex-maps';
const mapState = {
  center: [43.239543, 76.916644],
  zoom: 9
};

class HomePage extends Component {

  onYmapsLoad = (ymaps) => {
    this.ymaps = ymaps;
  };

  render() {
    return (
      <div className="map-wrapper">
        <YMaps query={{ lang: 'ru_RU' }} onLoad={this.onYmapsLoad}>
          <Map
            state={mapState}
            width='100%'
            height='400'
            instanceRef={(ref) => this.map = ref}
          />
        </YMaps>
      </div>
    );
  }
}
export default HomePage;